<template>
  <div :class="(errMessage.length) || hasErr ? 'errItem':''">
    <b-row :class="itemStyle">
      <b-col
        v-if="!noLabel"
        :sm="labelSize" class="right">
        <div :class="disabled?'badgeWrap pale':'badgeWrap'">
          <div v-if="isRequired" class="mr-2 badge badge-required">必須</div>
        </div>
        <label>{{ label }}</label>
      </b-col>
      <v-calendar
        :value="timeObj.ymd"
        @selected="changeData('ymd', $event)"
        :format="DatePickerFormat"
        :language="ja"
        :typeable="true"
        :input-class=" 'calendar ' + inputClass"
        :disabled="disabled"
        ref="picker"
        :calendar-button="true"
        calendar-button-icon="event"
      />
      <unicon name="calendar-alt"
        fill="#495057"
        class="calendar-icon"
        ></unicon>
      <b-col :sm="selectWrapSize" class="px-0 mr-1">
        <b-input-group
          :class="[ymdWrapClass]">
          <b-form-select
            :value="timeObj.time"
            @change="changeData('time', $event)"
            :class="['datetime', inputClass]"
            :disabled="disabled"
            :options="timeOption"/>
          <b-input-group-append
            class="ml-1 flex flexMiddle">
            時
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col
        v-if="!noMinute"
        :sm="selectWrapSize"
        class="px-0">
        <b-input-group
          :class="[ymdWrapClass]">
          <b-form-select
            :value="timeObj.minute"
            @change="changeData('minute', $event)"
            :class="['datetime', inputClass]"
            :disabled="disabled"
            :options="minuteOption"/>
          <b-input-group-append
            class="ml-1 flex flexMiddle">
            分
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <span class="error" v-if="errMessage">
      {{ errMessage[0] }}
    </span>
  </div>
</template>
<script>
import moment from 'moment';
import datepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
import TimeOptionHelper from '@/modules/TimeSelectBoxOption';

export default {
  name: 'CalendarDatetimeBox',
  components: {
    'v-calendar': datepicker,
  },
  props: {
    label: {},
    labelSize: { type: Number, default: 3 },
    itemStyle: {},
    value: { type: String, default: null },
    inputClass: {},
    selectWrapSize: { type: String, default: '2' },
    disabled: { type: Boolean, default: false },
    hasErr: { type: Boolean, default: false },
    errMessage: { type: Array, default: () => [] },
    isRequired: { type: Boolean, default: false },
    noLabel: { type: Boolean, default: false },
    noMinute: { type: Boolean, default: false },
    ymdWrapClass: { type: String, default: '' },
    updateParam: { type: Object, default: () => {} },
    canPast: { type: Boolean, default: true },
  },
  data() {
    return {
      DatePickerFormat: 'yyyy/MM/dd',
      ja,
      timeObj: {
        ymd: '',
        time: '',
        minute: '',
        second: '00',
      },
    };
  },
  watch: {
    value() {
      this.setData(this.value);
    },
  },
  methods: {
    async changeData(keyName, eValue) {
      let value = eValue;
      // カレンダーの場合は余計な要素が多数ついているのでYmdだけ取得する
      if (keyName === 'ymd') {
        value = moment(eValue).format('YYYY/MM/DD');
      }
      // localの各値にセットする。
      this.$set(this.timeObj, keyName, value);
      const emptyKey = Object.keys(this.timeObj).find((key) => {
        return this.timeObj[key] === '';
      });

      // セットされていない値があれば日付データを作らない
      if (emptyKey) {
        return;
      }
      const data = this.timeObj;
      // すべての日付が入力されたら、日付として有効かどうかをチェックする。
      const strValue = `${data.ymd} ${data.time}:${data.minute}:${data.second}`;
      if (!moment(strValue, 'YYYY/MM/DD HH:mm').isValid()) {
        return;
      }

      if (!this.canPast) {
        const newDt = moment(strValue);
        const now = moment();
        if (newDt.isBefore(now)) {
          await this.alert('過去の日付は設定できません。');
          this.init();
          return;
        }
      }

      const param = this.updateParam ? Object.assign(this.updateParam) : {};
      param.value = strValue;
      this.$emit('change', param);
    },
    init() {
      this.timeObj = {
        ymd: '',
        time: '',
        minute: '',
        second: '00',
      };
      if (this.noMinute) {
        this.timeObj.minute = '00';
      }
    },
    setData(value) {
      const t = moment(value, 'YYYY/MM/DD HH:mm').isValid() ? value : null;
      if (t === null) {
        this.init();
        return;
      }
      this.timeObj.ymd = moment(value).format('YYYY/MM/DD');
      this.timeObj.time = moment(value).format('HH');
      this.timeObj.minute = moment(value).format('mm');
      this.timeObj.second = '00';
    },
  },
  computed: {
  },
  created() {
    this.timeOption = TimeOptionHelper.getTimeOptionArray();
    this.minuteOption = TimeOptionHelper.getMinuteOptionArray();
    if (this.value) {
      const timeObj = {
        ymd: moment(this.value).format('YYYY/MM/DD'),
        time: moment(this.value).format('HH'),
        minute: moment(this.value).format('mm'),
        second: moment(this.value).format('ss'),
      };
      this.timeObj = timeObj;
    }
    // 分なし設定の場合、0分固定
    if (this.noMinute) {
      this.timeObj.minute = '00';
    }
  },
};
</script>
<style>
.line input.calendar{
  height: 50px;
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
input.w-small{
  width:175px;
}
.calendar-icon{
  position: relative;
  left: -32px;
}
.errItem input.calendar,
.errItem select.datetime {
  border:solid 1px #dc3545 !important;
}

.event {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  right: 1px;
  z-index: 1;
}

  .calendar:disabled {
    background-color: #F3F3F3 !important;
  }
</style>
<style scoped>
.line{
  align-items: center;
  margin:10px 0 !important;
}
.line label{
  align-items:center;
  margin:0;
}
.line .right{
  text-align: right;
}
.badgeWrap,
.label{
  display: inline-block;
}
.badgeWrap div{
  vertical-align: middle;
}
div.pale .badge-required{
  background: #d56e6e57;
}
.error{
  display:block;
  text-align: left;
  padding-left: 145px;
  margin-top: -6px;
  font-size: 80%;
  color: #dc3545;
}
input::-ms-clear {
  visibility:hidden
}
</style>
